import React, { useContext } from 'react';

import Button from '@/components/global/Button';

import Accordion from '../Accordion';
import AccordionItem from '../Accordion/AccordionItem';
import { FaqSearchContext } from '../FaqSearch/FaqSearchContext';
import RichText from '../RichText';
import styles from './FaqItems.module.scss';
import { getFilteredItems } from './helpers';
import { FaqItemsProps } from './types';

const FaqItems: React.FC<FaqItemsProps> = ({ items, title, notFoundTitle }) => {
  const { searchValue, selectedTag, selectedCategory } = useContext(FaqSearchContext);

  const filteredItems = getFilteredItems(items, searchValue, selectedTag);

  const actualTitle = filteredItems.length > 0 ? title : notFoundTitle;
  const renderItems = filteredItems.length > 0 ? filteredItems : items?.slice(0, 10);

  const getTitle = () =>
    searchValue || selectedTag ? (
      <RichText
        content={selectedCategory ? selectedCategory.name : actualTitle}
        align="center"
        maxWidth="1000"
        isSectionCentered={true}
        largeParagraphText={false}
      />
    ) : (
      <h4>All FAQs</h4>
    );

  return (
    <div className={styles.FaqItemsContainer}>
      <div className={styles.FaqItemsTitleWrapper}>{getTitle()}</div>
      {selectedCategory && (
        <div className={styles.FaqItemsCategoryWrapper}>
          <RichText
            content={selectedCategory.description}
            align="center"
            maxWidth="1000"
            isSectionCentered={true}
            largeParagraphText={false}
          />
        </div>
      )}

      <Accordion allowMultipleExpanded allowZeroExpanded>
        {renderItems?.map((faq) => (
          <AccordionItem
            key={faq._uid}
            title={faq.question}
            uid={faq._uid}
            iconColor="var(--color-primary)"
          >
            <div className={styles.FaqItemsAccordionItemContent}>
              <div className={styles.FaqItemsAccordionItemAnswerWrapper}>
                <RichText
                  content={faq.answer}
                  align="left"
                  isSectionCentered={false}
                  largeParagraphText={false}
                />
              </div>
              {faq.buttonText && (
                <Button
                  variant="secondary"
                  href={
                    faq.buttonHref.linktype === 'story'
                      ? faq.buttonHref.cached_url
                      : faq.buttonHref.url
                  }
                >
                  {faq.buttonText}
                </Button>
              )}
            </div>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FaqItems;
